/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "démb",
        "0": "tay",
        "1": "suba",
        "future": {
          "other": "fileek {0} fan"
        },
        "past": {
          "other": "{0} fan ci ginaaw"
        }
      },
      "day-narrow": {
        "-1": "démb",
        "0": "tay",
        "1": "suba",
        "future": {
          "other": "fileek {0} fan"
        },
        "past": {
          "other": "{0} fan ci ginaaw"
        }
      },
      "day-short": {
        "-1": "démb",
        "0": "tay",
        "1": "suba",
        "future": {
          "other": "fileek {0} fan"
        },
        "past": {
          "other": "{0} fan ci ginaaw"
        }
      },
      "hour": {
        "0": "ci waxtu wii",
        "future": {
          "other": "fileek {0} waxtu"
        },
        "past": {
          "other": "{0} waxtu ci ginaaw"
        }
      },
      "hour-narrow": {
        "0": "ci waxtu wii",
        "future": {
          "other": "fileek {0} wax."
        },
        "past": {
          "other": "{0} wax. ci ginaaw"
        }
      },
      "hour-short": {
        "0": "ci waxtu wii",
        "future": {
          "other": "fileek {0} wax."
        },
        "past": {
          "other": "{0} wax. ci ginaaw"
        }
      },
      "minute": {
        "0": "ci simili bii",
        "future": {
          "other": "fileek {0} simili"
        },
        "past": {
          "other": "{0} simili ci ginaaw"
        }
      },
      "minute-narrow": {
        "0": "ci simili bii",
        "future": {
          "other": "fileek {0} sim."
        },
        "past": {
          "other": "{0} sim. ci ginaaw"
        }
      },
      "minute-short": {
        "0": "ci simili bii",
        "future": {
          "other": "fileek {0} sim."
        },
        "past": {
          "other": "{0} sim. ci ginaaw"
        }
      },
      "month": {
        "-1": "weer wi weesu",
        "0": "weer wii",
        "1": "weer wiy ñëw",
        "future": {
          "other": "fileek {0} weer"
        },
        "past": {
          "other": "{0} weer ci ginaaw"
        }
      },
      "month-narrow": {
        "-1": "we. wi wees",
        "0": "we. wii",
        "1": "we. wiy ñëw",
        "future": {
          "other": "fileek {0} we."
        },
        "past": {
          "other": "{0} we. ci ginaaw"
        }
      },
      "month-short": {
        "-1": "we. wi wees",
        "0": "we. wii",
        "1": "we. wiy ñëw",
        "future": {
          "other": "fileek {0} we."
        },
        "past": {
          "other": "{0} we. ci ginaaw"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "trimestre bi weesu",
        "0": "trimestre bii",
        "1": "trimestre biy ñëw",
        "future": {
          "other": "fileek {0} trimestre"
        },
        "past": {
          "other": "{0} trimestre ci ginaaw"
        }
      },
      "quarter-narrow": {
        "-1": "trimestre bi weesu",
        "0": "trimestre bii",
        "1": "trimestre biy ñëw",
        "future": {
          "other": "fileek {0} trim."
        },
        "past": {
          "other": "{0} trim. ci ginaaw"
        }
      },
      "quarter-short": {
        "-1": "trimestre bi weesu",
        "0": "trimestre bii",
        "1": "trimestre biy ñëw",
        "future": {
          "other": "fileek {0} trim."
        },
        "past": {
          "other": "{0} trim. ci ginaaw"
        }
      },
      "second": {
        "0": "leegi",
        "future": {
          "other": "fileek {0} saa"
        },
        "past": {
          "other": "{0} saa ci ginaaw"
        }
      },
      "second-narrow": {
        "0": "leegi",
        "future": {
          "other": "fileek {0} saa"
        },
        "past": {
          "other": "{0} saa ci ginaaw"
        }
      },
      "second-short": {
        "0": "leegi",
        "future": {
          "other": "fileek {0} saa"
        },
        "past": {
          "other": "{0} saa ci ginaaw"
        }
      },
      "week": {
        "-1": "ayu-bis bi weesu",
        "0": "ayu-bis bii",
        "1": "ayu-bis biy ñëw",
        "future": {
          "other": "fileek {0} ayi-bis"
        },
        "past": {
          "other": "{0} ayi-bis ci ginaaw"
        }
      },
      "week-narrow": {
        "-1": "ayu-b bi wees",
        "0": "ayu-b bii",
        "1": "ayu-b. ñëw",
        "future": {
          "other": "fileek {0} ayi-b."
        },
        "past": {
          "other": "{0} ayi-b. ci ginaaw"
        }
      },
      "week-short": {
        "-1": "ayu-b bi wees",
        "0": "ayu-b bii",
        "1": "ayu-b. ñëw",
        "future": {
          "other": "fileek {0} ayi-b."
        },
        "past": {
          "other": "{0} ayi-b. ci ginaaw"
        }
      },
      "year": {
        "-1": "daaw",
        "0": "ren",
        "1": "dewen",
        "future": {
          "other": "fileek {0} at"
        },
        "past": {
          "other": "{0} at ci ginaaw"
        }
      },
      "year-narrow": {
        "-1": "daaw",
        "0": "ren",
        "1": "dewen",
        "future": {
          "other": "fileek {0} at"
        },
        "past": {
          "other": "{0} at ci ginaaw"
        }
      },
      "year-short": {
        "-1": "daaw",
        "0": "ren",
        "1": "dewen",
        "future": {
          "other": "fileek {0} at"
        },
        "past": {
          "other": "{0} at ci ginaaw"
        }
      }
    },
    "locale": "wo"
  });
}